import { Controller } from "@hotwired/stimulus"
import { get, subscribe } from "../lib/session_store"

// Heroicons outline 20px — one per tab group
const TAB_ICONS = {
  "speed-inputs": `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-5"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="2"/><path d="M12 14v5"/><path d="M6.3 9.26A5.99 5.99 0 0110 12"/><path d="M17.7 9.26A5.99 5.99 0 0014 12"/></svg>`,
  drivetrain: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-5"><path d="M12 15a3 3 0 100-6 3 3 0 000 6z"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 110-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06A1.65 1.65 0 0019.32 9a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>`,
  adjustments: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5"><path d="M17 2.75a.75.75 0 00-1.5 0v5.5a.75.75 0 001.5 0v-5.5zM17 15.75a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5zM3.75 15a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0v-1.5a.75.75 0 01.75-.75zM4.5 2.75a.75.75 0 00-1.5 0v5.5a.75.75 0 001.5 0v-5.5zM10 11a.75.75 0 01.75.75v5.5a.75.75 0 01-1.5 0v-5.5A.75.75 0 0110 11zM10.75 2.75a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5zM10 6a2 2 0 100 4 2 2 0 000-4zM3.75 10a2 2 0 100 4 2 2 0 000-4zM16.25 10a2 2 0 100 4 2 2 0 000-4z"/></svg>`,
  "g-forces": `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5"><path d="M10 3.75a2 2 0 10-4 0 2 2 0 004 0zM17.25 4.5a.75.75 0 000-1.5h-5.5a.75.75 0 000 1.5h5.5zM5 3.75a.75.75 0 01-.75.75h-1.5a.75.75 0 010-1.5h1.5a.75.75 0 01.75.75zM4.25 17a.75.75 0 000-1.5h-1.5a.75.75 0 000 1.5h1.5zM17.25 17a.75.75 0 000-1.5h-5.5a.75.75 0 000 1.5h5.5zM9 10a.75.75 0 01-.75.75h-5.5a.75.75 0 010-1.5h5.5A.75.75 0 019 10zM17.25 10.75a.75.75 0 000-1.5h-1.5a.75.75 0 000 1.5h1.5zM14 10a2 2 0 10-4 0 2 2 0 004 0zM10 16.25a2 2 0 10-4 0 2 2 0 004 0z"/></svg>`,
  "power-ers": `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5"><path d="M11.983 1.907a.75.75 0 00-1.292-.657l-8.5 9.5A.75.75 0 002.75 12h6.572l-1.305 6.093a.75.75 0 001.292.657l8.5-9.5A.75.75 0 0017.25 8h-6.572l1.305-6.093z"/></svg>`,
  tires: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm0-2a6 6 0 100-12 6 6 0 000 12zm0-3a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd"/></svg>`,
  "brakes-engine": `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5"><path fill-rule="evenodd" d="M7.84 1.804A1 1 0 018.82 1h2.36a1 1 0 01.98.804l.331 1.652a6.993 6.993 0 011.929 1.115l1.598-.54a1 1 0 011.186.447l1.18 2.044a1 1 0 01-.205 1.251l-1.267 1.113a7.047 7.047 0 010 2.228l1.267 1.113a1 1 0 01.206 1.25l-1.18 2.045a1 1 0 01-1.187.447l-1.598-.54a6.993 6.993 0 01-1.929 1.115l-.33 1.652a1 1 0 01-.98.804H8.82a1 1 0 01-.98-.804l-.331-1.652a6.993 6.993 0 01-1.929-1.115l-1.598.54a1 1 0 01-1.186-.447l-1.18-2.044a1 1 0 01.205-1.251l1.267-1.114a7.05 7.05 0 010-2.227L1.821 7.773a1 1 0 01-.206-1.25l1.18-2.045a1 1 0 011.187-.447l1.598.54A6.993 6.993 0 017.51 3.456l.33-1.652zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd"/></svg>`,
  "wheel-dynamics": `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5"><path fill-rule="evenodd" d="M10 2a8 8 0 100 16 8 8 0 000-16zM4 10a6 6 0 1112 0 6 6 0 01-12 0zM10 8a2 2 0 100 4 2 2 0 000-4zM9.25 4h1.5v4h-1.5V4zM9.25 12h1.5v4h-1.5v-4zM4 9.25h4v1.5H4v-1.5zM12 9.25h4v1.5h-4v-1.5z" clip-rule="evenodd"/></svg>`,
  suspension: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5"><path d="M17 2.75a.75.75 0 00-1.5 0v5.5a.75.75 0 001.5 0v-5.5zM17 15.75a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5zM3.75 15a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0v-1.5a.75.75 0 01.75-.75zM4.5 2.75a.75.75 0 00-1.5 0v5.5a.75.75 0 001.5 0v-5.5zM10 11a.75.75 0 01.75.75v5.5a.75.75 0 01-1.5 0v-5.5A.75.75 0 0110 11zM10.75 2.75a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5zM10 6a2 2 0 100 4 2 2 0 000-4zM3.75 10a2 2 0 100 4 2 2 0 000-4zM16.25 10a2 2 0 100 4 2 2 0 000-4z"/></svg>`,
  damage: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5"><path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"/></svg>`,
}

const ACTIVE_TAB_STORAGE_KEY = "telemetry-active-tab"

const TAB_GROUPS = [
  {
    id: "speed-inputs",
    label: "Speed & Inputs",
    charts: [
      {
        label: "Speed (km/h)",
        metrics: "speed_kmh",
        colors: "#FF2E92",
        height: "h-28",
        bg: "rgba(255,46,146,0.08)",
      },
      {
        label: "Throttle (%)",
        metrics: "throttle_pct",
        colors: "#22c55e",
        height: "h-28",
        bg: "rgba(34,197,94,0.08)",
        displayScale: 100,
      },
      {
        label: "Brake (%)",
        metrics: "brake_pct",
        colors: "#ef4444",
        height: "h-28",
        bg: "rgba(239,68,68,0.08)",
        displayScale: 100,
      },
      {
        label: "Steering",
        metrics: "steering_angle",
        colors: "#00D4FF",
        height: "h-28",
        bg: "rgba(0,212,255,0.08)",
      },
    ],
  },
  {
    id: "drivetrain",
    label: "Drivetrain",
    charts: [
      {
        label: "Gear",
        metrics: "gear",
        colors: "#6A00FF",
        height: "h-28",
        step: true,
        bg: "rgba(106,0,255,0.08)",
      },
      {
        label: "RPM",
        metrics: "engine_rpm",
        colors: "#f97316",
        height: "h-28",
        bg: "rgba(249,115,22,0.08)",
      },
      {
        label: "Clutch (%)",
        metrics: "clutch",
        colors: "#8b5cf6",
        height: "h-28",
        bg: "rgba(139,92,246,0.08)",
      },
      {
        label: "DRS",
        metrics: "drs",
        colors: "#eab308",
        height: "h-28",
        step: true,
        bg: "rgba(234,179,8,0.08)",
      },
    ],
  },
  {
    id: "adjustments",
    label: "In-Lap Adjustments",
    charts: [
      {
        label: "Diff (%)",
        metrics: "on_throttle_diff,off_throttle_diff",
        colors: "#22c55e,#ef4444",
        height: "h-28",
        step: true,
        legend: "On Throttle,Off Throttle",
      },
      {
        label: "Brake Bias (%)",
        metrics: "brake_bias",
        colors: "#3b82f6",
        height: "h-28",
        step: true,
        bg: "rgba(59,130,246,0.08)",
      },
      {
        label: "Front Wing",
        metrics: "front_wing",
        colors: "#f97316",
        height: "h-28",
        step: true,
        bg: "rgba(249,115,22,0.08)",
      },
      {
        label: "Fuel Mix",
        metrics: "fuel_mix",
        colors: "#a855f7",
        height: "h-28",
        step: true,
        bg: "rgba(168,85,247,0.08)",
      },
    ],
  },
  {
    id: "g-forces",
    label: "Dynamics",
    charts: [
      {
        label: "Lateral G",
        metrics: "g_lat",
        colors: "#3b82f6",
        height: "h-28",
      },
      {
        label: "Longitudinal G",
        metrics: "g_lon",
        colors: "#ef4444",
        height: "h-28",
      },
      {
        label: "Vertical G",
        metrics: "g_vert",
        colors: "#22c55e",
        height: "h-28",
      },
      {
        label: "Angular Velocity (\u00B0/s)",
        metrics: "angular_vel_x,angular_vel_y,angular_vel_z",
        colors: "#3b82f6,#f97316,#22c55e",
        height: "h-28",
        legend: "Yaw,Pitch,Roll",
      },
      {
        label: "Local Velocity (m/s)",
        metrics: "local_vel_x,local_vel_y,local_vel_z",
        colors: "#ef4444,#8b5cf6,#eab308",
        height: "h-28",
        legend: "X,Y,Z",
      },
    ],
  },
  {
    id: "power-ers",
    label: "Power & ERS",
    charts: [
      {
        label: "Engine Power (kW)",
        metrics: "engine_power_ice_kw,engine_power_mguk_kw",
        colors: "#ef4444,#3b82f6",
        height: "h-28",
        legend: "ICE,MGU-K",
      },
      {
        label: "ERS Energy (kJ)",
        metrics: "ers_store_energy",
        colors: "#22c55e",
        height: "h-28",
      },
      {
        label: "ERS Deploy Mode",
        metrics: "ers_deploy_mode",
        colors: "#8b5cf6",
        height: "h-28",
        step: true,
      },
      {
        label: "ERS Harvest (MJ)",
        metrics: "ers_harvested_mguk,ers_harvested_mguh",
        colors: "#f97316,#06b6d4",
        height: "h-28",
        legend: "MGU-K,MGU-H",
      },
      {
        label: "ERS Deployed (MJ)",
        metrics: "ers_deployed",
        colors: "#a855f7",
        height: "h-28",
      },
    ],
  },
  {
    id: "tires",
    label: "Tires",
    charts: [
      {
        label: "Surface Temps (\u00B0C)",
        metrics: "t_fl,t_fr,t_rl,t_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
      {
        label: "Inner Temps (\u00B0C)",
        metrics: "t_inner_fl,t_inner_fr,t_inner_rl,t_inner_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
      {
        label: "Pressures (PSI)",
        metrics:
          "tyre_pressure_fl,tyre_pressure_fr,tyre_pressure_rl,tyre_pressure_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
      {
        label: "Wear (%)",
        metrics: "tyre_wear_fl,tyre_wear_fr,tyre_wear_rl,tyre_wear_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
      {
        label: "Tire Damage (%)",
        metrics: "tyre_damage_fl,tyre_damage_fr,tyre_damage_rl,tyre_damage_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
      {
        label: "Tire Blisters",
        metrics:
          "tyre_blisters_fl,tyre_blisters_fr,tyre_blisters_rl,tyre_blisters_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
      {
        label: "Surface Type",
        metrics:
          "surface_type_fl,surface_type_fr,surface_type_rl,surface_type_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        step: true,
        legend: "FL,FR,RL,RR",
      },
    ],
  },
  {
    id: "brakes-engine",
    label: "Brakes & Engine",
    charts: [
      {
        label: "Brake Temps (\u00B0C)",
        metrics: "brake_temp_fl,brake_temp_fr,brake_temp_rl,brake_temp_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
      {
        label: "Brake Damage (%)",
        metrics:
          "brake_damage_fl,brake_damage_fr,brake_damage_rl,brake_damage_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
      {
        label: "Engine Temp (\u00B0C)",
        metrics: "engine_temperature",
        colors: "#ef4444",
        height: "h-28",
      },
      {
        label: "Engine Component Wear (%)",
        metrics:
          "engine_ice_wear,engine_mguk_wear,engine_mguh_wear,engine_tc_wear,engine_es_wear,engine_ce_wear",
        colors: "#ef4444,#3b82f6,#22c55e,#f97316,#8b5cf6,#06b6d4",
        height: "h-28",
        step: true,
        legend: "ICE,MGU-K,MGU-H,TC,ES,CE",
      },
      {
        label: "Fuel (kg)",
        metrics: "fuel_in_tank",
        colors: "#f97316",
        height: "h-28",
      },
    ],
  },
  {
    id: "wheel-dynamics",
    label: "Wheel Dynamics",
    charts: [
      {
        label: "Wheel Speed (m/s)",
        metrics: "wheel_speed_fl,wheel_speed_fr,wheel_speed_rl,wheel_speed_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
      {
        label: "Wheel Slip Ratio",
        metrics:
          "wheel_slip_ratio_fl,wheel_slip_ratio_fr,wheel_slip_ratio_rl,wheel_slip_ratio_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
      {
        label: "Wheel Slip Angle (\u00B0)",
        metrics:
          "wheel_slip_angle_fl,wheel_slip_angle_fr,wheel_slip_angle_rl,wheel_slip_angle_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
      {
        label: "Wheel Forces \u2014 Lateral (N)",
        metrics:
          "wheel_lat_force_fl,wheel_lat_force_fr,wheel_lat_force_rl,wheel_lat_force_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
      {
        label: "Wheel Forces \u2014 Longitudinal (N)",
        metrics:
          "wheel_long_force_fl,wheel_long_force_fr,wheel_long_force_rl,wheel_long_force_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
    ],
  },
  {
    id: "suspension",
    label: "Suspension & Aero",
    charts: [
      {
        label: "Suspension Position (mm)",
        metrics: "susp_pos_fl,susp_pos_fr,susp_pos_rl,susp_pos_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
      {
        label: "Suspension Velocity (mm/s)",
        metrics: "susp_vel_fl,susp_vel_fr,susp_vel_rl,susp_vel_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
      {
        label: "Suspension Acceleration (mm/s\u00B2)",
        metrics: "susp_accel_fl,susp_accel_fr,susp_accel_rl,susp_accel_rr",
        colors: "#3b82f6,#f97316,#22c55e,#ef4444",
        height: "h-28",
        legend: "FL,FR,RL,RR",
      },
      {
        label: "Aero Heights (mm)",
        metrics: "front_aero_height,rear_aero_height",
        colors: "#3b82f6,#ef4444",
        height: "h-28",
        legend: "Front,Rear",
      },
      {
        label: "Ride Height (mm)",
        metrics: "ride_height_cog",
        colors: "#8b5cf6",
        height: "h-28",
      },
      {
        label: "Roll Angles (\u00B0)",
        metrics: "front_roll_angle,rear_roll_angle",
        colors: "#22c55e,#ef4444",
        height: "h-28",
        legend: "Front,Rear",
      },
      {
        label: "Chassis Angles (\u00B0)",
        metrics: "chassis_yaw,chassis_pitch",
        colors: "#3b82f6,#f97316",
        height: "h-28",
        legend: "Yaw,Pitch",
      },
    ],
  },
  {
    id: "damage",
    label: "Damage",
    charts: [
      {
        label: "Wing Damage (%)",
        metrics: "front_left_wing_damage,front_right_wing_damage",
        colors: "#3b82f6,#f97316",
        height: "h-28",
        legend: "Front Left,Front Right",
      },
      {
        label: "Rear & Body (%)",
        metrics: "rear_wing_damage,floor_damage,diffuser_damage,sidepod_damage",
        colors: "#ef4444,#8b5cf6,#22c55e,#f97316",
        height: "h-28",
        legend: "Rear Wing,Floor,Diffuser,Sidepod",
      },
      {
        label: "Engine & Gearbox (%)",
        metrics: "engine_damage,gearbox_damage",
        colors: "#dc2626,#a855f7",
        height: "h-28",
        legend: "Engine,Gearbox",
      },
      {
        label: "System Faults",
        metrics: "drs_fault,ers_fault,engine_blown,engine_seized",
        colors: "#eab308,#8b5cf6,#dc2626,#f97316",
        height: "h-28",
        step: true,
        legend: "DRS,ERS,Blown,Seized",
      },
    ],
  },
]

export default class extends Controller {
  static targets = [
    "tabs",
    "tabsWrapper",
    "groups",
    "child",
    "deltaSlot",
    "comparisonLegend",
    "comparisonLabel",
  ]
  static values = {
    lapId: Number,
    comparison: { type: Boolean, default: false },
    laps: Array,
    telemetry: Array,
    deltaMode: { type: Boolean, default: false },
    sector1Ms: Number,
    sector2Ms: Number,
    sector2Distance: Number,
    sector3Distance: Number,
    sectorsMs: Array,
    sectorDistances: Array,
  }

  connect() {
    this.activeTab =
      sessionStorage.getItem(ACTIVE_TAB_STORAGE_KEY) || "speed-inputs"
    this.telemetryData = null
    this.comparisonLaps = null
    this._zoomState = get("zoomRange") ?? null
    this._materializedGroups = new Set()
    this._cachedActiveGroup = null
    this._cachedCharts = null
    this._visibleGroups = null

    this.handleHover = (e) => this._onHover(e)
    this.handleLeave = (e) => this._onLeave(e)
    this.handleZoomBubble = (e) => this._onZoomBubble(e)

    this.element.addEventListener("telemetry:hover", this.handleHover)
    this.element.addEventListener("telemetry:leave", this.handleLeave)
    this.element.addEventListener("telemetry:zoom", this.handleZoomBubble)

    this._comparisonLapId = get("comparisonLapId") ?? null

    this._unsubs = [
      subscribe("zoomRange", (range) => {
        this._zoomState = range
      }),
      subscribe("comparisonLapId", (id) => {
        this._onComparisonChange(id)
      }),
    ]

    this._fetchTelemetry()
  }

  disconnect() {
    this._unsubs?.forEach((fn) => fn())
    this.element.removeEventListener("telemetry:hover", this.handleHover)
    this.element.removeEventListener("telemetry:leave", this.handleLeave)
    this.element.removeEventListener("telemetry:zoom", this.handleZoomBubble)
    if (this._tabScrollCleanup) {
      this._tabScrollCleanup()
      this._tabScrollCleanup = null
    }
  }

  // --- Telemetry fetching (absorbed from telemetry-sync) ---

  async _fetchTelemetry() {
    // Reset comparison state when no comparison lap is selected
    if (!this._comparisonLapId) {
      this.comparisonValue = false
      this.lapsValue = []
    }

    if (this._comparisonLapId && this.hasLapIdValue && this.lapIdValue > 0) {
      // Inline comparison mode: fetch both laps
      this.comparisonValue = true
      this.lapsValue = [
        { id: this.lapIdValue, color: "#3b82f6" },
        { id: this._comparisonLapId, color: "#f97316" },
      ]
      await this._fetchComparisonTelemetry()
    } else if (this.hasLapIdValue && this.lapIdValue > 0) {
      await this._fetchSingleTelemetry()
    } else if (this.hasTelemetryValue && this.telemetryValue.length > 0) {
      this._onTelemetryReady({ telemetry: this.telemetryValue, laps: null })
    }
  }

  async _fetchSingleTelemetry() {
    try {
      const resp = await fetch(`/laps/${this.lapIdValue}/telemetry`)
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
      const data = await resp.json()
      this.telemetryValue = data
      this._onTelemetryReady({ telemetry: data, laps: null })
    } catch (err) {
      console.error("Failed to fetch telemetry:", err)
      this._onTelemetryReady({ telemetry: [], laps: null })
    }
  }

  async _fetchComparisonTelemetry() {
    const lapConfigs = this.lapsValue
    try {
      const comparisonLabel = get("comparisonLapLabel") || "Comparison"
      const fetches = lapConfigs.map(async (cfg, i) => {
        const resp = await fetch(`/laps/${cfg.id}/telemetry`)
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
        const data = await resp.json()
        return {
          telemetry: data,
          color: cfg.color,
          id: cfg.id,
          driverName: i === 0 ? "You" : comparisonLabel,
        }
      })
      const laps = await Promise.all(fetches)

      if (laps.length > 0) {
        this.telemetryValue = laps[0].telemetry
      }

      this._onTelemetryReady({ telemetry: laps[0]?.telemetry || [], laps })
    } catch (err) {
      console.error("Failed to fetch comparison telemetry:", err)
      this._onTelemetryReady({ telemetry: [], laps: [] })
    }
  }

  // --- PiP (absorbed from telemetry-sync) ---

  openVideoPip() {
    const trackMap = this.element.querySelector(
      "[data-controller~='track-map']",
    )
    this.dispatch("enterPip", { detail: { anchor: trackMap }, bubbles: true })
  }

  // --- Telemetry processing ---

  _onTelemetryReady({ telemetry, laps }) {
    this.telemetryData = telemetry
    this.comparisonLaps = laps

    const payload = { telemetry, laps, zoomState: this._zoomState }

    // Dispatch to child targets (track-map, delta chart, etc.)
    this.childTargets.forEach((child) => {
      child.dispatchEvent(
        new CustomEvent("telemetry:loaded", { detail: payload }),
      )
    })

    // Render tabs and dispatch to charts
    const sampleRow = this._getSampleRow()
    this._renderTabs(sampleRow)
    this._renderCharts()
    this._dispatchToVisibleCharts(payload)

    // Show/hide delta slot and comparison legend
    this._updateComparisonUI(laps, payload)
  }

  _onComparisonChange(comparisonId) {
    const newId = comparisonId || null
    if (newId === this._comparisonLapId) return
    this._comparisonLapId = newId
    this._fetchTelemetry()
  }

  _updateComparisonUI(laps, payload) {
    const isComparison = laps && laps.length > 1

    // Comparison legend
    if (this.hasComparisonLegendTarget) {
      this.comparisonLegendTarget.classList.toggle("hidden", !isComparison)
      if (isComparison && this.hasComparisonLabelTarget) {
        const label = get("comparisonLapLabel")
        if (label) {
          const escaped = label.replace(/</g, "&lt;")
          this.comparisonLabelTarget.innerHTML =
            `<span class="inline-block w-5 h-0 shrink-0 border-t-2 border-dashed" style="border-color: #f97316;"></span>` +
            `<span class="text-[11px] font-medium text-white/50">${escaped}</span>`
        }
      }
    }

    // Delta slot
    if (this.hasDeltaSlotTarget) {
      if (isComparison) {
        this.deltaSlotTarget.classList.remove("hidden")
        // Materialize delta chart if not already present
        if (
          !this.deltaSlotTarget.querySelector(
            "[data-controller='telemetry-chart']",
          )
        ) {
          const wrapper = document.createElement("div")
          wrapper.className = "relative px-1 pb-5"
          wrapper.style.background =
            "linear-gradient(to bottom, rgba(239,68,68,0.06), transparent 40%, transparent 60%, rgba(34,197,94,0.06))"
          wrapper.dataset.controller = "telemetry-chart"
          wrapper.dataset.telemetryChartComparisonValue = "true"
          wrapper.dataset.telemetryChartDeltaModeValue = "true"
          wrapper.dataset.telemetryChartLabelValue = "Delta (s)"
          if (this.hasSectorsMsValue && this.sectorsMsValue.length > 0)
            wrapper.dataset.telemetryChartSectorsMsValue = JSON.stringify(
              this.sectorsMsValue,
            )
          if (
            this.hasSectorDistancesValue &&
            this.sectorDistancesValue.length > 0
          )
            wrapper.dataset.telemetryChartSectorDistancesValue = JSON.stringify(
              this.sectorDistancesValue,
            )
          if (this.hasSector1MsValue)
            wrapper.dataset.telemetryChartSector1MsValue = this.sector1MsValue
          if (this.hasSector2MsValue)
            wrapper.dataset.telemetryChartSector2MsValue = this.sector2MsValue
          if (this.hasSector2DistanceValue)
            wrapper.dataset.telemetryChartSector2DistanceValue =
              this.sector2DistanceValue
          if (this.hasSector3DistanceValue)
            wrapper.dataset.telemetryChartSector3DistanceValue =
              this.sector3DistanceValue

          const canvas = document.createElement("div")
          canvas.className = "h-28"
          canvas.dataset.telemetryChartTarget = "canvas"
          wrapper.appendChild(canvas)

          const title = document.createElement("span")
          title.className =
            "absolute bottom-1.5 left-3 text-xs font-semibold pointer-events-none"
          title.style.color = "rgba(255,255,255,0.35)"
          title.textContent = "\u0394 Delta (s)"
          wrapper.appendChild(title)

          // +/- indicators on the right
          const indicators = document.createElement("div")
          indicators.className =
            "absolute bottom-1.5 right-3 flex items-center gap-2 text-[10px] font-medium pointer-events-none"
          indicators.innerHTML = `<span style="color: rgba(239,68,68,0.6);">+\u2009slower</span><span style="color: rgba(34,197,94,0.6);">\u2212\u2009faster</span>`
          wrapper.appendChild(indicators)

          this.deltaSlotTarget.innerHTML = ""
          this.deltaSlotTarget.appendChild(wrapper)
        }

        // Dispatch telemetry to delta chart
        requestAnimationFrame(() => {
          const deltaChart = this.deltaSlotTarget.querySelector(
            "[data-controller='telemetry-chart']",
          )
          if (deltaChart) {
            deltaChart.dispatchEvent(
              new CustomEvent("telemetry:loaded", { detail: payload }),
            )
          }
        })
      } else {
        this.deltaSlotTarget.classList.add("hidden")
        this.deltaSlotTarget.innerHTML = ""
      }
    }
  }

  _onHover(event) {
    const { index, source } = event.detail
    // Forward to child targets (track-map, delta chart, etc.)
    this.childTargets.forEach((child) => {
      if (child !== source) {
        child.dispatchEvent(
          new CustomEvent("sync:hover", { detail: { index } }),
        )
      }
    })
    // Forward to sibling charts
    this._reDispatchToCharts("sync:hover", event)
  }

  _onLeave(event) {
    // Forward to child targets
    this.childTargets.forEach((child) => {
      child.dispatchEvent(new CustomEvent("sync:leave"))
    })
    // Forward to sibling charts
    this._reDispatchToCharts("sync:leave", event)
  }

  _onZoomBubble(event) {
    const { distanceRange, source } = event.detail
    this._zoomState = distanceRange

    // Forward to child targets
    this.childTargets.forEach((child) => {
      if (child !== source) {
        child.dispatchEvent(
          new CustomEvent("sync:zoom", { detail: { distanceRange, source } }),
        )
      }
    })
    // Forward to sibling charts
    this._reDispatchToCharts("sync:zoom", event)
  }

  _getSampleRow() {
    if (this.comparisonLaps && this.comparisonLaps.length > 0) {
      const firstLap = this.comparisonLaps[0]
      return firstLap.telemetry && firstLap.telemetry.length > 0
        ? firstLap.telemetry[0]
        : {}
    }
    return this.telemetryData && this.telemetryData.length > 0
      ? this.telemetryData[0]
      : {}
  }

  _hasAnyMetric(sampleRow, chart) {
    const metrics = chart.metrics.split(",")
    return metrics.some((m) => sampleRow[m] !== undefined)
  }

  _getVisibleGroups(sampleRow) {
    return TAB_GROUPS.filter((group) => {
      // Speed & Inputs always visible (core charts always present)
      if (group.id === "speed-inputs") return true
      return group.charts.some((chart) => this._hasAnyMetric(sampleRow, chart))
    })
  }

  _renderTabs(sampleRow) {
    const container = this.tabsTarget
    container.innerHTML = ""

    const visibleGroups = this._getVisibleGroups(sampleRow)

    // Fall back to first tab if stored tab is not available
    if (!visibleGroups.some((g) => g.id === this.activeTab)) {
      this.activeTab = visibleGroups[0]?.id || "speed-inputs"
    }

    visibleGroups.forEach((group) => {
      const wrapper = document.createElement("div")
      wrapper.className = "relative"

      const btn = document.createElement("button")
      btn.type = "button"
      btn.dataset.tabId = group.id
      btn.addEventListener("click", () => this._switchTab(group.id))

      const isActive = group.id === this.activeTab
      const icon = TAB_ICONS[group.id] || ""
      btn.className = isActive
        ? "inline-flex items-center justify-center gap-1.5 border-b-2 border-white/40 p-2.5 text-xs font-medium text-white/70 whitespace-nowrap"
        : "inline-flex items-center justify-center border-b-2 border-transparent p-2.5 text-white/40 hover:border-white/30 hover:text-white/70"
      btn.innerHTML = isActive ? `${icon}<span>${group.label}</span>` : icon

      wrapper.appendChild(btn)
      container.appendChild(wrapper)

      // Tooltip popover on hover — appended to tabsWrapper (outside overflow-x-auto nav)
      if (this.hasTabsWrapperTarget) {
        const tooltip = document.createElement("div")
        tooltip.className =
          "absolute px-2 py-1 rounded bg-black text-xs text-white whitespace-nowrap opacity-0 pointer-events-none transition-opacity z-50"
        tooltip.textContent = group.label
        this.tabsWrapperTarget.appendChild(tooltip)

        wrapper.addEventListener("mouseenter", () => {
          const btnRect = btn.getBoundingClientRect()
          const wrapperRect = this.tabsWrapperTarget.getBoundingClientRect()
          tooltip.style.left = `${btnRect.left + btnRect.width / 2 - wrapperRect.left}px`
          tooltip.style.top = `${btnRect.bottom - wrapperRect.top + 4}px`
          tooltip.style.transform = "translateX(-50%)"
          tooltip.style.opacity = "1"
        })
        wrapper.addEventListener("mouseleave", () => {
          tooltip.style.opacity = "0"
        })
      }
    })

    this._setupTabScroll()
  }

  // --- Tab scroll overflow ---

  _setupTabScroll() {
    if (!this.hasTabsWrapperTarget) return
    const wrapper = this.tabsWrapperTarget
    const nav = this.tabsTarget

    // Clean up previous
    if (this._tabScrollCleanup) {
      this._tabScrollCleanup()
      this._tabScrollCleanup = null
    }

    // Remove old chevrons/gradients if re-rendering
    wrapper.querySelectorAll("[data-tab-scroll]").forEach((el) => el.remove())

    const CHEVRON_SVG = `<svg class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" /></svg>`

    // Left edge: solid bg behind chevron + gradient fade
    const leftEdge = document.createElement("div")
    leftEdge.dataset.tabScroll = "left"
    leftEdge.className =
      "absolute left-0 top-0 bottom-0 flex items-center z-10 pointer-events-none opacity-0 transition-opacity duration-150"
    leftEdge.innerHTML = `
      <button class="pointer-events-auto flex items-center justify-center w-6 h-full bg-app-hud-bg text-white/60 hover:text-white transition-colors rotate-180">${CHEVRON_SVG}</button>
      <div class="w-6 h-full bg-gradient-to-r from-gray-950 to-transparent"></div>`
    wrapper.appendChild(leftEdge)

    // Right edge: gradient fade + solid bg behind chevron
    const rightEdge = document.createElement("div")
    rightEdge.dataset.tabScroll = "right"
    rightEdge.className =
      "absolute right-0 top-0 bottom-0 flex items-center z-10 pointer-events-none opacity-0 transition-opacity duration-150"
    rightEdge.innerHTML = `
      <div class="w-6 h-full bg-gradient-to-l from-gray-950 to-transparent"></div>
      <button class="pointer-events-auto flex items-center justify-center w-6 h-full bg-glossy-black-blue rounded-tr-lg text-white/60 hover:text-white transition-colors">${CHEVRON_SVG}</button>`
    wrapper.appendChild(rightEdge)

    const leftBtn = leftEdge.querySelector("button")
    const rightBtn = rightEdge.querySelector("button")

    const SCROLL_STEP = 80

    const updateEdges = () => {
      const canScrollLeft = nav.scrollLeft > 1
      const canScrollRight =
        nav.scrollLeft < nav.scrollWidth - nav.clientWidth - 1
      leftEdge.style.opacity = canScrollLeft ? "1" : "0"
      leftEdge.style.pointerEvents = canScrollLeft ? "auto" : "none"
      rightEdge.style.opacity = canScrollRight ? "1" : "0"
      rightEdge.style.pointerEvents = canScrollRight ? "auto" : "none"
    }

    const scrollLeft = () => {
      nav.scrollBy({ left: -SCROLL_STEP, behavior: "smooth" })
    }
    const scrollRight = () => {
      nav.scrollBy({ left: SCROLL_STEP, behavior: "smooth" })
    }

    leftBtn.addEventListener("click", scrollLeft)
    rightBtn.addEventListener("click", scrollRight)
    nav.addEventListener("scroll", updateEdges, { passive: true })

    const ro = new ResizeObserver(updateEdges)
    ro.observe(nav)

    // Initial check after layout settles
    requestAnimationFrame(updateEdges)

    this._tabScrollCleanup = () => {
      leftBtn.removeEventListener("click", scrollLeft)
      rightBtn.removeEventListener("click", scrollRight)
      nav.removeEventListener("scroll", updateEdges)
      ro.disconnect()
    }
  }

  _renderCharts() {
    const container = this.groupsTarget
    container.innerHTML = ""

    const sampleRow = this._getSampleRow()
    this._visibleGroups = this._getVisibleGroups(sampleRow)
    this._materializedGroups.clear()
    this._invalidateCache()

    this._visibleGroups.forEach((group) => {
      const groupDiv = document.createElement("div")
      groupDiv.dataset.groupId = group.id
      groupDiv.className =
        group.id === this.activeTab ? "space-y-2" : "space-y-2 hidden"

      // Only populate chart controllers for the active tab (lazy rendering)
      if (group.id === this.activeTab) {
        this._materializeGroup(groupDiv, group, sampleRow)
      }

      container.appendChild(groupDiv)
    })
  }

  _materializeGroup(groupDiv, group, sampleRow) {
    if (this._materializedGroups.has(group.id)) return
    this._materializedGroups.add(group.id)

    if (!sampleRow) sampleRow = this._getSampleRow()
    const visibleCharts = group.charts.filter((chart) =>
      this._hasAnyMetric(sampleRow, chart),
    )

    visibleCharts.forEach((chart) => {
      const chartWrapper = document.createElement("div")
      if (chart.bg) {
        chartWrapper.className = "relative px-1 pb-5"
        chartWrapper.style.backgroundColor = chart.bg
      } else {
        chartWrapper.className = "relative bg-app-hud-bg px-1 pb-5"
      }
      chartWrapper.dataset.controller = "telemetry-chart"
      const isSingleMetric = !chart.metrics.includes(",")
      if (isSingleMetric) {
        chartWrapper.dataset.telemetryChartAxisColorValue = chart.colors
      }
      chartWrapper.dataset.telemetryChartMetricValue = chart.metrics
      chartWrapper.dataset.telemetryChartColorValue = chart.colors
      chartWrapper.dataset.telemetryChartLabelValue = chart.label
      if (chart.displayScale)
        chartWrapper.dataset.telemetryChartDisplayScaleValue =
          chart.displayScale
      if (chart.step) chartWrapper.dataset.telemetryChartStepValue = "true"
      if (chart.legend)
        chartWrapper.dataset.telemetryChartLegendValue = chart.legend
      if (this.comparisonValue)
        chartWrapper.dataset.telemetryChartComparisonValue = "true"
      if (this.deltaModeValue && chart.metrics === "__delta__") {
        chartWrapper.dataset.telemetryChartDeltaModeValue = "true"
      }
      if (this.hasSectorsMsValue && this.sectorsMsValue.length > 0)
        chartWrapper.dataset.telemetryChartSectorsMsValue = JSON.stringify(
          this.sectorsMsValue,
        )
      if (this.hasSectorDistancesValue && this.sectorDistancesValue.length > 0)
        chartWrapper.dataset.telemetryChartSectorDistancesValue =
          JSON.stringify(this.sectorDistancesValue)
      if (this.hasSector1MsValue)
        chartWrapper.dataset.telemetryChartSector1MsValue = this.sector1MsValue
      if (this.hasSector2MsValue)
        chartWrapper.dataset.telemetryChartSector2MsValue = this.sector2MsValue
      if (this.hasSector2DistanceValue)
        chartWrapper.dataset.telemetryChartSector2DistanceValue =
          this.sector2DistanceValue
      if (this.hasSector3DistanceValue)
        chartWrapper.dataset.telemetryChartSector3DistanceValue =
          this.sector3DistanceValue

      const canvas = document.createElement("div")
      canvas.className = chart.height
      canvas.dataset.telemetryChartTarget = "canvas"
      chartWrapper.appendChild(canvas)

      // Title label — bottom-left, overlaid
      const title = document.createElement("span")
      title.className =
        "absolute bottom-1.5 left-3 text-xs font-semibold pointer-events-none"
      if (isSingleMetric) {
        title.style.color = chart.colors
        title.style.opacity = "0.6"
      } else {
        title.className += " text-white/40"
      }
      title.textContent = chart.label
      chartWrapper.appendChild(title)

      // Legend — bottom-right, overlaid (no overlap with bottom-left title)
      if (chart.legend) {
        const legendDiv = document.createElement("div")
        legendDiv.className = "absolute bottom-1.5 right-3 z-10"
        legendDiv.dataset.telemetryChartTarget = "legend"
        chartWrapper.appendChild(legendDiv)
      }

      groupDiv.appendChild(chartWrapper)
    })
  }

  _switchTab(tabId) {
    this.activeTab = tabId
    try {
      sessionStorage.setItem(ACTIVE_TAB_STORAGE_KEY, tabId)
    } catch (_) {
      /* ignore */
    }
    this._invalidateCache()

    // Update tab button styles and labels
    const buttons = this.tabsTarget.querySelectorAll("button[data-tab-id]")
    const visibleGroups = this._visibleGroups || []
    buttons.forEach((btn) => {
      const id = btn.dataset.tabId
      const isActive = id === tabId
      const group = visibleGroups.find((g) => g.id === id)
      const icon = TAB_ICONS[id] || ""
      btn.className = isActive
        ? "inline-flex items-center justify-center gap-1.5 border-b-2 border-white/40 p-2.5 text-xs font-medium text-white/70 whitespace-nowrap"
        : "inline-flex items-center justify-center border-b-2 border-transparent p-2.5 text-white/40 hover:border-white/30 hover:text-white/70"
      btn.innerHTML = isActive
        ? `${icon}<span>${group?.label || ""}</span>`
        : icon
      if (isActive) {
        requestAnimationFrame(() =>
          btn.scrollIntoView({ inline: "nearest", behavior: "smooth" }),
        )
      }
    })

    // Toggle group visibility
    const groups = this.groupsTarget.querySelectorAll("[data-group-id]")
    groups.forEach((group) => {
      group.classList.toggle("hidden", group.dataset.groupId !== tabId)
    })

    // Materialize chart controllers if this tab hasn't been populated yet
    if (!this._materializedGroups.has(tabId)) {
      const groupDiv = this.groupsTarget.querySelector(
        `[data-group-id="${tabId}"]`,
      )
      const group = this._visibleGroups?.find((g) => g.id === tabId)
      if (groupDiv && group) {
        this._materializeGroup(groupDiv, group)
      }
    }

    // Dispatch telemetry to newly visible charts (with current zoom state)
    if (this.telemetryData || this.comparisonLaps) {
      this._dispatchToVisibleCharts({
        telemetry: this.telemetryData,
        laps: this.comparisonLaps,
        zoomState: this._zoomState,
      })
    }
  }

  _dispatchToVisibleCharts(detail) {
    // Wait for Stimulus to connect the new chart controllers
    requestAnimationFrame(() => {
      const charts = this._getActiveCharts()
      charts.forEach((chart) => {
        chart.dispatchEvent(new CustomEvent("telemetry:loaded", { detail }))
      })
    })
  }

  _reDispatchToCharts(eventName, event) {
    // Forward sync events to all chart controllers in the active group (cached)
    const charts = this._getActiveCharts()
    const source = event.detail?.source
    for (let i = 0; i < charts.length; i++) {
      if (charts[i] !== source) {
        charts[i].dispatchEvent(
          new CustomEvent(eventName, { detail: event.detail }),
        )
      }
    }
    // Also forward to delta chart in slot
    if (this.hasDeltaSlotTarget) {
      const deltaChart = this.deltaSlotTarget.querySelector(
        "[data-controller='telemetry-chart']",
      )
      if (deltaChart && deltaChart !== source) {
        deltaChart.dispatchEvent(
          new CustomEvent(eventName, { detail: event.detail }),
        )
      }
    }
  }

  // Cached DOM query for active group's chart elements
  _getActiveCharts() {
    if (this._cachedCharts) return this._cachedCharts

    const activeGroup = this.groupsTarget.querySelector(
      `[data-group-id="${this.activeTab}"]`,
    )
    if (!activeGroup) return []

    this._cachedActiveGroup = activeGroup
    this._cachedCharts = Array.from(
      activeGroup.querySelectorAll('[data-controller="telemetry-chart"]'),
    )
    return this._cachedCharts
  }

  _invalidateCache() {
    this._cachedActiveGroup = null
    this._cachedCharts = null
  }
}
